export const management = {
  routes: [
    {
      path: "/management/log",
      component: () => import("../log-view"),
    },
  ],
};
